import { render } from "./WomensHealthSelectedTests.vue?vue&type=template&id=a2ef8a2a"
import script from "./WomensHealthSelectedTests.vue?vue&type=script&lang=js"
export * from "./WomensHealthSelectedTests.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/selectedTestsPreview/WomensHealthSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2ef8a2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2ef8a2a', __exports__)) {
    console.log('reload')
    api.reload('a2ef8a2a', __exports__)
  }
  
  module.hot.accept("./WomensHealthSelectedTests.vue?vue&type=template&id=a2ef8a2a", () => {
    console.log('re-render')
    api.rerender('a2ef8a2a', render)
  })

}


export default __exports__